export default class ManagersGrid {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.cards = this.passedElement.querySelectorAll('.manager-card');
        this.wait;
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    handleCardClick = (card) => {
        card.classList.contains('open') ? card.classList.remove('open') : card.classList.add('open');
    }

    handleCloseAllCards = () => {
        this.cards.forEach((card) => {
            card.classList.remove('open');
        })
    }

    handleResize = () => {
        if ( window.innerWidth <= 760 ) this.handleCloseAllCards();
        return null;
    }

    getElements = () => {
    }

    addEventListeners = () => {
        this.cards.forEach((card) => {
            ['click','ontouchstart'].forEach((evt) => {
                card.addEventListener(evt, () => this.handleCardClick(card));
            });
        });

        window.addEventListener('resize', () => {
            clearTimeout(this.wait);
            this.wait = setTimeout(this.handleResize, 100);
        });

    }
}